import {
  CancelPackageReasonsService,
  type PostPutCancelPackageReasonTranslationAdmin
} from '@/backend/market'
import { CancelPackageReasonRepository } from '../../domain/repositories/CancelPackageReasonRepository'
import { CancelPackageReasonModel } from '../models/CancelPackageReasonModel'
import { CancelPackageReasonMiniModel } from '../models/CancelPackageReasonMiniModel'
import type { CancelPackageReasonMiniEntity } from '../../domain/entities/CancelPackageReasonMiniEntity'
import type { CancelPackageReasonEntity } from '../../domain/entities/CancelPackageReasonEntity'

export class CancelPackageReasonRepositoryImpl implements CancelPackageReasonRepository {
  async getCancelPackageReasons(): Promise<CancelPackageReasonMiniEntity[] | { error: true }> {
    try {
      const response = await CancelPackageReasonsService.getCancelPackageReasonsAdmin({})
      const cancelPackageReasonModels = response.map(
        (reason) => new CancelPackageReasonMiniModel(reason)
      )

      return cancelPackageReasonModels
    } catch {
      return { error: true }
    }
  }
  async getCancelPackageReasonById(
    id: number
  ): Promise<CancelPackageReasonEntity | { error: true }> {
    try {
      const response = await CancelPackageReasonsService.getCancelPackageReasonByIdAdmin({
        id
      })
      const cancelPackageReasonModel = new CancelPackageReasonModel(response)

      return cancelPackageReasonModel
    } catch {
      return { error: true }
    }
  }
  async createCancelPackageReason(
    data: CancelPackageReasonEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      await CancelPackageReasonsService.postCancelPackageReasonAdmin({
        requestBody: {
          translations: data.translations?.map((translation) => ({
            language: translation.language,
            title: translation.title
          })) as PostPutCancelPackageReasonTranslationAdmin[]
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateCancelPackageReason(
    id: number,
    data: CancelPackageReasonEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      await CancelPackageReasonsService.putCancelPackageReasonAdmin({
        id,
        requestBody: {
          translations: data.translations?.map((translation) => ({
            language: translation.language,
            title: translation.title
          })) as PostPutCancelPackageReasonTranslationAdmin[]
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteCancelPackageReason(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await CancelPackageReasonsService.deleteCancelPackageReasonAdmin({
        id
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
